// sharedArchetype.js — the Relationship Archetype share link.
// A result shares https://theweb.love/?r=<archetype key>. Opened signed out,
// the landing shows that archetype above the usual start. The key is taken
// out of the address bar so a reload or a re-shared address doesn't carry it.

const KEY_RE = /^[a-z]{2,20}$/;

export function captureSharedArchetype() {
  const params = new URLSearchParams(window.location.search);
  const raw = params.get('r');
  if (raw === null) return null;
  params.delete('r');
  const qs = params.toString();
  window.history.replaceState(null, '', `${window.location.pathname}${qs ? `?${qs}` : ''}${window.location.hash}`);
  const key = raw.trim().toLowerCase();
  return KEY_RE.test(key) ? key : null;
}
